import {
  useSettingsNavigationEntities,
  useSidebarNavigationEntities,
} from 'hooks/useNavigationEntities';
import { useEffect } from 'react';
import { useStores } from 'stores/rootStore';

export const usePathSyncers = () => {
  const { pageStore } = useStores();
  const { selectedNavigationEntity: sidebarSelectedNavigationEntity } =
    useSidebarNavigationEntities();
  const { selectedNavigationEntity: settingsSelectedNavigationEntity } =
    useSettingsNavigationEntities();

  useEffect(() => {
    if (sidebarSelectedNavigationEntity != null) {
      pageStore.setSidebarPath(sidebarSelectedNavigationEntity.absolutePath);
    }
  }, [sidebarSelectedNavigationEntity, pageStore]);

  useEffect(() => {
    if (settingsSelectedNavigationEntity != null) {
      pageStore.setSelectedSettingPath(settingsSelectedNavigationEntity.absolutePath);
    }
  }, [settingsSelectedNavigationEntity, pageStore]);
};
